class BundleCarousel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick.bind(this));
    this.addEventListener('change', this.#handleChange.bind(this));
    this.#initArrows();
    this.#initZoom();
    this.#initSizeSelects();
  }

  #initSizeSelects() {
    const filterSize = (this.dataset.filterSize || '').trim();
    if (!filterSize) return;
    this.querySelectorAll('.czb-card').forEach(card => {
      const select = card.querySelector('.czb-card__size');
      const addBtn = card.querySelector('.czb-card__add');
      if (!select || !addBtn) return;
      // Chercher l'option dont le texte correspond à la taille du panier
      const opt = Array.from(select.options).find(o => o.text.trim() === filterSize);
      if (opt) {
        select.value = opt.value;
        addBtn.dataset.variantId = opt.value;
      }
    });
  }

  #initZoom() {
    let lb = null;
    this.addEventListener('mouseover', (e) => {
      const zoom = e.target.closest('.czb-card__zoom');
      if (!zoom) return;
      const img = zoom.closest('.czb-card__img')?.querySelector('img');
      if (!img) return;
      // Image en haute résolution
      const src = img.src.replace(/width=\d+/, 'width=480');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'czb-lightbox';
        lb.innerHTML = '<img>';
        document.body.appendChild(lb);
      }
      lb.querySelector('img').src = src;
      // Position : au-dessus et centré sur la loupe
      const r = zoom.getBoundingClientRect();
      const lw = 280, lh = 280;
      let top  = r.top - lh - 10;
      let left = r.left + r.width / 2 - lw / 2;
      if (top < 8) top = r.bottom + 10;
      if (left < 8) left = 8;
      if (left + lw > window.innerWidth - 8) left = window.innerWidth - lw - 8;
      lb.style.top  = top  + 'px';
      lb.style.left = left + 'px';
      lb.classList.add('is-visible');
    });
    this.addEventListener('mouseout', (e) => {
      if (!lb) return;
      const from = e.target.closest('.czb-card__zoom');
      const to   = e.relatedTarget?.closest?.('.czb-card__zoom');
      if (from && !to) lb.classList.remove('is-visible');
    });
  }

  #initArrows() {
    const track = this.querySelector('.czb__track');
    const prev  = this.querySelector('.czb__arrow--prev');
    const next  = this.querySelector('.czb__arrow--next');
    if (!track || !next) return;
    const update = () => {
      const atStart = track.scrollLeft <= 4;
      const atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
    };
    track.addEventListener('scroll', update, { passive: true });
    update();
    prev?.addEventListener('click', (e) => {
      e.stopPropagation();
      track.scrollBy({ left: -110, behavior: 'smooth' });
    });
    next?.addEventListener('click', (e) => {
      e.stopPropagation();
      track.scrollBy({ left: 110, behavior: 'smooth' });
    });
  }

  #handleClick(e) {
    if (e.target.closest('.czb-card__zoom')) { e.preventDefault(); return; }
    const swatch = e.target.closest('.czb-swatch');
    if (swatch) { this.#selectSwatch(swatch); return; }
    const addBtn = e.target.closest('.czb-card__add');
    if (addBtn) { e.preventDefault(); this.#addToCart(addBtn); }
  }

  #handleChange(e) {
    const select = e.target.closest('.czb-card__size');
    if (!select) return;
    const card = select.closest('.czb-card');
    card.querySelector('.czb-card__add').dataset.variantId = select.value;
  }

  #selectSwatch(swatch) {
    const card = swatch.closest('.czb-card');
    card.querySelectorAll('.czb-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    const jsonEl = card.querySelector('.czb-card__variants-json');
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch { return; }

    const color      = swatch.dataset.color;
    const filterSize = this.dataset.filterSize || '';

    // Filtrer par couleur uniquement
    const colorVars = variants.filter(v =>
      (v.o1 || '').toLowerCase().replace(/ /g, '-') === color
    );
    if (!colorVars.length) return;

    // Dédupliquer par taille
    const seen = new Set();
    const uniqueSizes = colorVars.filter(v => {
      if (seen.has(v.o2)) return false;
      seen.add(v.o2); return true;
    });

    const addBtn     = card.querySelector('.czb-card__add');
    const sizeSelect = card.querySelector('.czb-card__size');
    if (sizeSelect) {
      sizeSelect.innerHTML = uniqueSizes
        .map(v => `<option value="${v.id}"${filterSize && v.o2 === filterSize ? ' selected' : ''}>${v.o2 || ''}</option>`)
        .join('');
    }
    // Variant par défaut : taille filtrée si dispo, sinon premier
    const preferred = filterSize ? colorVars.find(v => v.o2 === filterSize) : null;
    addBtn.dataset.variantId = (preferred || colorVars[0]).id;

    if (colorVars[0].img) {
      const img = card.querySelector('img');
      if (img) img.src = colorVars[0].img;
    }
  }

  async #addToCart(btn) {
    const variantId = parseInt(btn.dataset.variantId);
    if (!variantId || isNaN(variantId)) return;
    if (btn.classList.contains('is-loading')) return; /* un clic = un ajout (mesure : un événement par vrai ajout) */
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    /* 26/10/2026 (« quand le panier est déjà rempli, l'ajout rapide est trop long ») : la jauge 2+1, la jauge de
       livraison offerte et le compteur bougent AU CLIC (window.czPanier.optimiste) ; la réponse du serveur re-pose
       le tiroir entier et corrige l'estimation ; en cas d'échec, tout revient à l'état d'avant et le message
       d'échec traduit s'affiche sous le carrousel. */
    const annuler = window.czPanier && window.czPanier.optimiste
      ? window.czPanier.optimiste({ prixCents: Number(btn.dataset.czPrix) || 0, bracelet: true })
      : () => {};

    /* Horizon (lot D, 21/10) : ajout par window.czPanier (assets/cz-panier.js), qui re-rend le tiroir. */
    try {
      if (window.czPanier) await window.czPanier.ajouter([{ id: variantId, quantity: 1 }], 'cz-panier-bundle-carousel');
    } catch (err) {
      annuler();
      this.#erreur();
      console.error('[bundle-carousel]', err);
    } finally {
      /* après un succès, le bouton a déjà été remplacé par le rendu serveur : sans effet */
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  }

  #erreur() {
    const txt = this.dataset.txtErreur;
    if (!txt) return;
    /* Après un échec, Horizon re-rend le tiroir depuis le serveur (état réel du panier), ce qui retirerait le
       message : il est reposé tant que ses cinq secondes ne sont pas écoulées. */
    const fin = Date.now() + 5000;
    const poser = () => {
      if (Date.now() > fin) return;
      let el = this.querySelector('.czb__erreur');
      if (!el) {
        el = document.createElement('p');
        el.className = 'czb__erreur';
        el.setAttribute('role', 'alert');
        el.style.cssText = 'margin:8px 0 0;font-size:13px;color:#b42318;';
        this.appendChild(el);
      }
      if (el.textContent !== txt) el.textContent = txt;
    };
    poser();
    if (this._czObs) this._czObs.disconnect();
    this._czObs = new MutationObserver(() => poser());
    this._czObs.observe(this, { childList: true });
    clearTimeout(this._czErreurT);
    this._czErreurT = setTimeout(() => {
      if (this._czObs) this._czObs.disconnect();
      const el = this.querySelector('.czb__erreur');
      if (el) el.remove();
    }, 5000);
  }
}

if (!customElements.get('bundle-carousel')) {
  customElements.define('bundle-carousel', BundleCarousel);
}

/* Horizon (lot D, 21/10) : écouteurs globaux repris du snippet bundle-carousel (choix de taille, zoom photo). */
(function(){
  if (window.__czbGlobal) return;
  window.__czbGlobal = true;

document.addEventListener('change', function(e) {
  var sel = e.target.closest('.czb-card__size');
  if (!sel) return;
  var card = sel.closest('.czb-card');
  if (!card) return;
  var jsonEl = card.querySelector('.czb-card__variants-json');
  if (!jsonEl) return;
  var variants = JSON.parse(jsonEl.textContent);
  var selText = sel.options[sel.selectedIndex].text;
  var activeSwatch = card.querySelector('.czb-swatch.is-active');
  var activeColor = activeSwatch ? activeSwatch.getAttribute('title') : null;
  var match = null;
  for (var i = 0; i < variants.length; i++) {
    if (variants[i].o2 === selText && (!activeColor || variants[i].o1 === activeColor)) { match = variants[i]; break; }
  }
  if (!match) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].o2 === selText) { match = variants[i]; break; }
    }
  }
  if (match) {
    var img = card.querySelector('.czb-card__img img');
    if (img && match.img) img.src = match.img;
    var addBtn = card.querySelector('.czb-card__add');
    if (addBtn) addBtn.setAttribute('data-variant-id', match.id);
  }
});


(function(){
  if (window.__czbZoomBound) return;
  window.__czbZoomBound = true;
  document.addEventListener('click', function(e){
    var z = e.target.closest('[data-czb-zoom]');
    if (z) {
      e.preventDefault();
      e.stopPropagation();
      var src = z.getAttribute('data-czb-zoom');
      if (!src) return;
      var ov = document.createElement('div');
      ov.className = 'czb-zoomlb';
      ov.innerHTML = '<img src="' + src + '" alt="">';
      ov.addEventListener('click', function(){ ov.remove(); });
      document.body.appendChild(ov);
      requestAnimationFrame(function(){
        ov.classList.add('is-open');
        ov.style.opacity = '1';
      });
      return;
    }
    var open = document.querySelector('.czb-zoomlb');
    if (open) open.remove();
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.czb-zoomlb');
    if (open) open.remove();
  });
})();

})();
